<template>
  <div class="asc-input-field--container asc-input-field--container-textfield">
    <v-text-field
      v-model="model"
      v-bind="getSharedAttrs"
      @blur="handleBlur"
      @focus="focus = true"
      @click="handleClick"
    >
      <template v-if="appendIcon">
        <v-icon slot="append">{{ appendIcon }}</v-icon>
      </template>
      <template v-if="label" #label>
        <div>
          <div v-if="labelIcon" class="withIcon">
            <asc-alert-icon :status="labelIcon"></asc-alert-icon>
            <span>{{ label }}</span>
          </div>
          <asc-required-label v-else :label="label" :required="required" />
        </div>
      </template>
      <template v-if="hasCounter" #counter="{ props }">
        <v-counter v-bind="props" :value="getCounterValue"></v-counter>
      </template>
    </v-text-field>
  </div>
</template>

<script>
import { AscInputMixin } from '@/components/mixins'
import AscAlertIcon from '@/components/atoms/AscAlertIcon'

export default {
  name: 'AscTextFieldInput',

  components: {
    AscAlertIcon,
  },

  mixins: [AscInputMixin],
}
</script>
